import React from 'react';
import PropTypes from 'prop-types';
// styles
import styled, { css } from 'styled-components';

const SwitchOption = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  background-color: var(--white);
  color: var(--grey700);
  border-radius: 4px;
  width: 100%;
  height: 48px;
  ${(props) =>
    !!props.isSelected &&
    css`
      background-color: var(--grey500);
      color: var(--white);
    `};
`;

const Switch = ({ className, value, options }) => (
  <div className={className}>
    {options.map((option) => (
      <SwitchOption
        key={option.value}
        onClick={option.onClick}
        isSelected={value === option.value}
      >
        {option.label}
      </SwitchOption>
    ))}
  </div>
);

Switch.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default styled(Switch)`
  border: 1px solid var(--grey500);
  border-radius: 4px;
  display: flex;
`;
